import { visualNodes } from "../nodes.js";

const queued = {};
const rendered = {};
const appends = [];

const attachRoot = (eNode) => {
  const rootElement = document.querySelector("#root");
  rendered[eNode.uid] = rootElement;
  visualNodes.set(eNode.uid, eNode);
  return rootElement;
};

// TODO tag should be required
const create = (eNode, tag) => {
  //console.error("element create", eNode.uid, eNode)
  let parentUid = eNode.props.parentUid;
  let uid = eNode.uid;
  let element;

  if (typeof tag === "string") {
    // should create a tag using the tag name
    element = document.createElement(tag);
  } else {
    if (typeof tag.nodeName === "string") {
      // element was already created (e.g. images, video)
      element = tag;
      tag = element.nodeName;
    } else {
      throw new TypeError("Unrecognized tag name: " + tag);
    }
  }
  element.id = uid;
  element.style.position = "absolute";
  element.style.overflow = "visible";
  element.style.boxSizing = "border-box";
  element.style.userSelect = "none";
  element.style.webkitUserSelect = "none";

  // Add namespace as data attribute for visibility
  if (eNode.namespace) {
    element.setAttribute('data-namespace', eNode.namespace);
  }

  // Add templateUid as data attribute for template tracking
  if (eNode.props && eNode.props.templateUid) {
    element.setAttribute('data-template-uid', eNode.props.templateUid);
  }

  queued[uid] = element;

  visualNodes.set(uid, eNode);

  if (rendered[parentUid]) {
    // create a document fragment to append this
    if (!queued[parentUid]) {
      queued[parentUid] = document.createDocumentFragment();
    }
    queued[parentUid].append(element);

    // add the parent's uid to the list of appends to be done
    if (!appends.includes(parentUid)) {
      appends.push(parentUid);
    }
  } else {
    // the parent has not yet rendered
    if (queued[parentUid]) {
      queued[parentUid].append(element);
    } else {
      // Can happen if the layout and its children are removed in the same animation cycle and the queue still has an "add" events on children
      console.error(`Can't find parent: ${parentUid}`);
    }
  }

  return element;
};

const addChild = (eNode) => {
  const parent = visualNodes.get(eNode.props.parentUid);
  if (!parent) {
    // Can happen if children have "add" event in the queue, but parent was removed
    return;
  }

  //depth is used to update css recursively
  eNode.depth = parent.depth + 1;
  if (parent.children) {
    parent.children.push(eNode);
  } else {
    parent.children = [eNode];
  }
};

const moveChild = (eNode) => {
  const oldParentUid = eNode.element.parentElement.id;
  const newParentUid = eNode.props.parentUid;
  if (oldParentUid === newParentUid) {
    return;
  }
  const newParent = visualNodes.get(newParentUid);
  if (!newParent) {
    eNode.props.parentUid = oldParentUid;
  }

  // TODO does this automatically remove child of oldParent?
  newParent.element.append(eNode.element);
};

// TODO should only have eNode as argument
// seems to be some cleanup in this and next static
const removeChild = (parent, eNode) => {
  //removes eNode from parent's children array
  if (!parent.children) {
    return;
  }

  for (let index = 0; index < parent.children.length; index++) {
    if (parent.children[index] === eNode) {
      parent.children.splice(index, 1);
      break;
    }
  }
};

// TODO should have eNode as argument
// or maybe not since it is called from the updateDom static
const remove = (eNodeUid) => {
  const eNode = visualNodes.get(eNodeUid);

  const parent = visualNodes.get(eNode.props.parentUid);
  removeChild(parent, eNode);
  // TODO parent.element might not exist
  // don't know why
  try {
    if (!eNode.isObject3D) {
      eNode.element.remove();
    }
  } catch (error) {
    console.error(error);
  }
  recursiveRemove(eNode);
};

const recursiveRemove = (eNode) => {
  if (eNode.children && eNode.children.length > 0) {
    for (let index = 0; index < eNode.children.length; index++) {
      recursiveRemove(eNode.children[index]);
    }
  } else {
    /* empty */
  }

  eNode.envImplementation.destroy(eNode);

  visualNodes.delete(eNode.uid);
  delete rendered[eNode.uid];
  delete queued[eNode.uid];
};

// resolve all pending append operations
const flush = () => {
  let parentUid;
  let parent;
  let uids;
  let uid;
  let ii;
  let index;

  let fragment;

  if (appends.length > 0) {
    for (index = 0, ii = appends.length; index < ii; index++) {
      parentUid = appends[index];
      fragment = queued[parentUid];
      parent = rendered[parentUid];
      // TODO safety, can apparently happen
      if (parent) {
        parent.append(fragment);
      } else {
        // TODO check naming here
        console.error("parent uid not exist", parentUid);
      }
      delete queued[parentUid];
    }

    appends.length = 0;

    // move rendered nodes from queued hash to rendered hash
    uids = Object.keys(queued);
    for (index = 0, ii = uids.length; index < ii; index++) {
      uid = uids[index];
      rendered[uid] = queued[uid];
      delete queued[uid];
    }
  }
};

const getNode = (uid) => {
  return rendered[uid] || queued[uid];
};

export { addChild, attachRoot, create, flush, getNode, moveChild, remove, removeChild };
